import React from 'react'
import Translation from '../../global/Translation'
import { injectIntl } from 'react-intl'
import { getShowSaleConditions } from '../../../store/ui/reducers'
import { connect } from 'react-redux'
import { toggleSaleConditionsCheck } from '../../../store/checkout/actions'
import {getSalesOrg} from "../../../store/centers/reducers";
import { getLanguage } from '../../../store/ui/reducers'
import { getSaleConditionsCheck } from '../../../store/checkout/reducers'
import { getUsaCaPrTermsAndConditionsByLang } from '../../../helpers'

const mapStateToProps = state => {
    return {
        showSaleConditions: getShowSaleConditions(state),
        getSalesOrg: getSalesOrg(state),
        language: getLanguage(state),
        hasSaleConditionsCheck: getSaleConditionsCheck(state),
    }
}
const mapDispatchToProps = dispatch => {
    return {
        toggleSaleConditionsCheck: checked => {
            dispatch(toggleSaleConditionsCheck(checked))
        }
    }
}

const getSaleConditions = language => {
    switch (language) {
        case 'ja':
            return 'https://assetstools.cosentino.com/api/v1/bynder/doc/A884253C-7651-41C1-9FB78391C988EDAD/cgv-ja.pdf'
        case 'da':
            return 'https://assetstools.cosentino.com/api/v1/bynder/doc/9AD69489-9925-4A10-AA54D5A26BDC81BF/cgv-da.pdf'
        case 'tr':
            return 'https://assetstools.cosentino.com/api/v1/bynder/doc/CCFDE483-2EE4-4211-90A1E6756700E90A/cgv-tr.pdf'
        case 'he':
            return 'https://assetstools.cosentino.com/api/v1/bynder/doc/EBFB9B63-78F0-43A0-A50DE2C473E93251/cgv-he.pdf'
        default:
            return 'https://assetstools.cosentino.com/api/v1/bynder/doc/511A2D40-054A-41D5-89CE81CF6DB105D8/cgv.pdf'
    }
}

class CheckboxLinkSaleConditions extends React.Component {
    render() {
        if (!this.props.showSaleConditions) return null
        const usaSalesOrgs = ['2011', '2032', '2037'];

        if (usaSalesOrgs.includes(this.props.getSalesOrg)) {
          return (
            <React.Fragment>
              <label className={`CheckboxLinkSaleConditions ${this.props.disabled && 'CheckboxLinkSaleConditions-disabled'}`} data-qas="checkout_steptwo-general-conditions-checkbox">
                <input name="sales_conditions_check"
                       type="checkbox"
                       onClick={input => this.props.toggleSaleConditionsCheck(input.target.checked)}
                       disabled={this.props.disabled}
                />{' '}

                <span className='checkmark' />
                <Translation id="i_accept_the" defaultMessage="I accept the" />{' '}
                <a href={getUsaCaPrTermsAndConditionsByLang(this.props.language)} target="_blank" rel="nofollow noopener noreferrer">
                  <Translation id="general_conditions_of_sale" defaultMessage="General conditions of sale" />
                </a>{' '}
                <Translation id="of_cosentino" defaultMessage="of Cosentino" />
              </label>         
            </React.Fragment>
          )
        } else {
          return (
            <React.Fragment>
              <label className={`CheckboxLinkSaleConditions ${this.props.disabled && 'CheckboxLinkSaleConditions-disabled'}`} data-qas="checkout_steptwo-general-conditions-checkbox">
                  <input name="sales_conditions_check"
                         type="checkbox"
                         onClick={input => this.props.toggleSaleConditionsCheck(input.target.checked)}
                         disabled={this.props.disabled}
                  />{' '}
                  <span className='checkmark' />
                  <Translation id="i_accept_the" defaultMessage="I accept the" />{' '}
                  <a href={getSaleConditions(this.props.language)} target="_blank" rel="nofollow noopener noreferrer">
                      <Translation id="general_conditions_of_sale" defaultMessage="General conditions of sale" />
                  </a>{' '}
                <Translation id="of_cosentino" defaultMessage="of Cosentino" />
              </label>
            </React.Fragment>
          )
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(CheckboxLinkSaleConditions))
